import { Attachments } from "@/assets/icons";
import { InputValidatedProps } from "@/components/input-validated/types";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./styles.scss";
import { transformFileFormats, validateFile } from "./utils";

export const InputFile = forwardRef<HTMLInputElement, InputValidatedProps>(
  (
    {
      id = "file",
      label,
      placeholder,
      labelClassName,
      messageClass,
      errorMessage,
      successMessage,
      helperMessage,
      requiredOnly,
      onChange,
      ...rest
    },
    ref,
  ) => {
    const requiredOnlyFormats = transformFileFormats(requiredOnly);

    return (
      <>
        <input
          ref={ref}
          type="file"
          id={id}
          className={clsx(styles.uploadInput)}
          accept={requiredOnlyFormats}
          onChange={e => {
            const file = e.target.files?.[0];
            const isValid = validateFile(file);

            if (isValid && onChange) {
              return onChange(e);
            }
          }}
          {...rest}
        />

        <label
          htmlFor={id}
          className={clsx(styles.uploadDocumentsButton, labelClassName)}
        >
          {label ? (
            label
          ) : (
            <>
              <span>{placeholder}</span>
              <Attachments className={styles.icon} />
            </>
          )}
        </label>

        {messageClass && (
          <span className={clsx(styles.message, messageClass)}>
            {errorMessage || successMessage || helperMessage}
          </span>
        )}
      </>
    );
  },
);
